import React, { Component } from "react";
import { Card, Grid, Icon, Statistic, Table } from "semantic-ui-react";
import StockByWarehouse from "./components/StockByWarehouse";
import SoldByWarehouse from "./components/SoldByWarehouse";
import OrderForm from "./components/OrderForm";
import PropTypes from "prop-types";

import {PROCUREMENT_WAREHOUSE_ID} from "../../../Procurement";

class DetailTab extends Component {

    render() {

        const { product, warehouses, orders, suppliers, targets,orderAmount } = this.props;
        return (
            <div style={{ padding: "20px" }}>

                <Grid verticalAlign='middle' columns={5}>
                    <Grid.Row>
                        <Grid.Column>
                            <Statistic>
                                <Statistic.Value>{product.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID]}</Statistic.Value>
                                <Statistic.Label>Stock</Statistic.Label>
                            </Statistic>
                        </Grid.Column>
                        <Grid.Column>
                            <Icon size='big' name='arrow right'/>
                        </Grid.Column>
                        <Grid.Column>
                            <Statistic>

                                <Statistic.Value>{product.reorderLevel}</Statistic.Value>
                                <Statistic.Label>Reorder
                                    Point</Statistic.Label>
                            </Statistic>
                        </Grid.Column>
                        <Grid.Column>
                            <Icon size='big' name='arrow right'/>
                        </Grid.Column>
                        <Grid.Column>
                            <Statistic>
                                <Statistic.Value>{orderAmount}</Statistic.Value>
                                <Statistic.Label>Order
                                    Amount</Statistic.Label>
                            </Statistic>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid columns={3}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>
                                        Details
                                    </Card.Header>
                                    <Card.Description>
                                        <Table celled>
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>Field</Table.HeaderCell>
                                                    <Table.HeaderCell>Value</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                <Table.Row>
                                                    <Table.Cell>{"Main Supplier"}</Table.Cell>
                                                    <Table.Cell>{product.supplier}</Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>{"Latest Supplier"}</Table.Cell>
                                                    <Table.Cell>{product.latestSupplier}</Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>{"Purchase Price"}</Table.Cell>
                                                    <Table.Cell>{product.cost}</Table.Cell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.Cell>{"Latest Purchase Price"}</Table.Cell>
                                                    <Table.Cell>{product.latestPurchasePrice}</Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column width={16}>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>Stock in
                                        Warehouses</Card.Header>
                                    <Card.Description>
                                        <StockByWarehouse
                                            stockByWarehouse={product.inStockByWarehouse}
                                            warehouses={warehouses}
                                            targets={Object.keys(product.soldByWarehouseAdjusted)
                                                .reduce((object, warehouse) => {
                                                    if (targets && targets[product.id] && typeof targets[product.id][warehouse] !== "undefined") {
                                                        object[warehouse] = targets[product.id][warehouse];
                                                    } else {
                                                        object[warehouse] = Math.ceil(product.soldByWarehouseAdjusted[warehouse] / 3);
                                                    }
                                                    return object;
                                                }, {})}
                                            suggestedTargets={Object.keys(product.soldByWarehouseAdjusted)
                                                .reduce((object, warehouse) => {
                                                    object[warehouse] = Math.ceil(product.soldByWarehouseAdjusted[warehouse] / 3);
                                                    return object;
                                                }, {})}
                                            onTargetChange={(warehouse_id, target) => {
                                                this.props.onTargetChange(product.id, warehouse_id, target);
                                            }}
                                        />
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                        <Grid.Column width={16}>
                            <Card fluid>
                                <Card.Content>
                                    <Card.Header>Sold by
                                        Warehouses</Card.Header>
                                    <Card.Description>
                                        <SoldByWarehouse
                                            soldByWarehouse={product.soldByWarehouse}
                                            soldByWarehouseAdjusted={product.soldByWarehouseAdjusted}
                                            warehouses={warehouses}
                                        />
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid columns={1}>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <OrderForm
                                active={!(orders && orders[product.id])}
                                onRemove={() => {
                                    this.props.removeProductOnOrder(product.id);
                                }}


                                onSubmit={(amount, supplier_id, supplierCode, cost) => {

                                    this.props.setProductOnOrder(product.id,
                                        {
                                            supplier_id,
                                            amount,
                                            id: product.id,
                                            code: product.code,
                                            name: product.name,
                                            supplierCode,
                                            cost,
                                        }
                                    );

                                }}
                                onRefreshPrices={() => {
                                    this.props.onRefreshPrices();
                                }}
                                suppliers={suppliers}
                                product={product}
                                supplierID={product.supplier_id}
                                supplierPrices={this.props.supplierPrices}
                                orderAmount={Math.ceil(Number.parseInt(product.reorderLevel, 10) * 1.5) - Number.parseInt(product.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID], 10)}/>

                        </Grid.Column>
                    </Grid.Row>
                </Grid>

            </div>
        );
    }
}


DetailTab.propTypes = {
    product: PropTypes.object.isRequired,
    orderAmount: PropTypes.number.isRequired,
    suppliers: PropTypes.array.isRequired,
    orders: PropTypes.object.isRequired,
    warehouses: PropTypes.array.isRequired,
    setProductOnOrder: PropTypes.func.isRequired,
    removeProductOnOrder: PropTypes.func.isRequired,
    onTargetChange: PropTypes.func.isRequired,
    targets: PropTypes.object.isRequired,
    supplierPrices: PropTypes.object.isRequired
};


export default DetailTab;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/DetailTab/index.js